import { useQuery } from "@tanstack/react-query";
import { fetchFunctionalSummaries, fetchFunctionalSummariesWithTeamScores } from "../services/functional_summaries";

const GetFunctionalSummary = (
  patient,
  startDate = null,
  endDate = null,
  scores = null,
  providerIds = null,
  functionalIssues = null,
  fromDate = null,
  toDate = null,
  includeTeamScores = false,
  includeHistory = true
) => {
  const functionalSummaries = useQuery({
    queryKey: [
      "functional_summary",
      patient,
      startDate,
      endDate,
      scores,
      providerIds,
      functionalIssues,
      fromDate,
      toDate,
      includeTeamScores,
      includeHistory
    ],
    queryFn: () => {
      if (includeTeamScores) {
        return fetchFunctionalSummariesWithTeamScores(
        patient,
        startDate,
        endDate,
        scores,
        providerIds,
        functionalIssues,
        fromDate,
        toDate
      );
      } else {
        return fetchFunctionalSummaries(
          patient,
          startDate,
          endDate,
        scores,
        providerIds,
        functionalIssues,
        fromDate,
        toDate,
        includeHistory
      );
      }
    },
    enabled: !!patient,
  });
  return functionalSummaries;
};

export default GetFunctionalSummary;
